import React from 'react';
import {withRouter} from 'react-router-dom';
import {StateMachineProvider, createStore} from 'little-state-machine';
import {DevTool} from 'little-state-machine-devtools';
import {Container, Paper, Box} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import {LocalizationProvider} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

const styles = {
    root: {
        paddingTop: '1em',
        paddingRight: '2em',
        paddingLeft: '2em',
    },
};

createStore({
    data: {},
});

const SimpleForm = ({classes, title, content, node}) => {
    return (
        <LocalizationProvider dateAdapter={MomentUtils}>
            <Container maxWidth='sm'>
                <Paper elevation={2}>
                    <StateMachineProvider>
                        <Box className={classes.root}>
                            {process.env.NODE_ENV !== 'production' && (
                                <DevTool />
                            )}
                            <h1 className='o-form-title'>{title}</h1>
                            {React.createElement(content.component, {
                                initialValues: content.initialValues,
                                shema: content.schema,
                                node,
                            })}
                        </Box>
                    </StateMachineProvider>
                </Paper>
            </Container>
        </LocalizationProvider>
    );
};
export default withStyles(styles)(withRouter(SimpleForm));
